module.exports = __webpack_public_path__ + "static/media/employer_image.ed7138eb.png";